module.exports = __webpack_public_path__ + "static/media/Canada.b26c4c94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Canada.jpg
// module id = 986
// module chunks = 0